import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { BRAND } from "@/config/brand";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AppConfigProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("minit_lang") || "ms");
  const [config, setConfig] = useState({ branding: BRAND, plans: [], integrations: [] });

  useEffect(() => {
    api.get("/public/config").then((r) => setConfig({ ...r.data, branding: { ...BRAND, ...r.data.branding } })).catch(() => {});
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = `${config.branding.app_name} — ${lang === "ms" ? "Minit mesyuarat AI" : "AI meeting minutes"}`;
  }, [lang, config.branding.app_name]);

  const setLang = (l) => {
    localStorage.setItem("minit_lang", l);
    setLangState(l);
  };
  const L = useCallback((ms, en) => (lang === "en" ? en : ms), [lang]);
  return <Ctx.Provider value={{ lang, setLang, L, brand: config.branding, config }}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);

export const LANGS = [
  ["ms", "Bahasa Melayu", "Malay"],
  ["en", "English", "English"],
];

export const STATUS_LABEL = {
  bot_scheduled: ["Bot dijadualkan", "Bot scheduled"],
  bot_joining: ["Bot menyertai", "Bot joining"],
  bot_recording: ["Bot merakam", "Bot recording"],
  bot_processing: ["Mengambil rakaman", "Fetching recording"],
  queued: ["Dalam giliran", "Queued"],
  preparing_audio: ["Menyediakan audio", "Preparing audio"],
  transcribing: ["Mentranskrip", "Transcribing"],
  polishing: ["Memulihkan transkrip", "Polishing transcript"],
  generating_notes: ["Menjana nota", "Generating notes"],
  completed: ["Selesai", "Completed"],
  failed: ["Gagal", "Failed"],
};
